module.exports = __webpack_public_path__ + "static/media/4.fa164217.jpg";